var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { useCookies } from 'react-cookie';
import { Box, FlexGrid, Typography, ToggleSwitch, StackView, RadioGroup, Divider, Spacer, Icon } from '@telus-uds/components-web';
import palette from '@telus-uds/palette-koodo';
import { MaintenanceFilled } from '@telus-uds/palette-koodo/build/web/icons';
import styled from 'styled-components';
import Drawer from '../Drawer/Drawer';
export var DebuggerFeatureFlags = function (_a) {
    var _b, _c, _d;
    var flags = _a.flags;
    var modifiedFlags = Object.keys(flags).reduce(function (acc, key) {
        if (key !== 'role')
            acc[key] = flags[key] ? 1 : 0;
        return acc;
    }, {});
    var _e = useCookies(['globalConfigOverride', 'userRole']), cookies = _e[0], setCookie = _e[1], removeCookie = _e[2];
    var _f = useState(__assign(__assign({}, modifiedFlags), cookies.globalConfigOverride)), featureFlags = _f[0], setFeatureFlags = _f[1];
    var _g = useState(false), reloadPageOnClose = _g[0], setReloadPageOnClose = _g[1];
    var _h = useState((_c = (_b = cookies.userRole) !== null && _b !== void 0 ? _b : flags.role) !== null && _c !== void 0 ? _c : 'none'), userRole = _h[0], setUserRole = _h[1];
    var triggerRef = useRef(null);
    var buttonRef = useRef(null);
    var flagEntries = Object.entries(featureFlags);
    var overrideFlags = Object.keys((_d = cookies.globalConfigOverride) !== null && _d !== void 0 ? _d : []);
    var handleUpdateFlag = function (key, value) {
        var _a, _b;
        var updatedFlags = __assign(__assign({}, featureFlags), (_a = {}, _a[key] = value, _a));
        var updatedCookie = __assign(__assign({}, cookies.globalConfigOverride), (_b = {}, _b[key] = value, _b));
        setFeatureFlags(updatedFlags);
        setCookie('globalConfigOverride', updatedCookie, { path: '/', domain: '.koodomobile.com' });
        setReloadPageOnClose(true);
    };
    var handleUpdateRole = function (role) {
        if (role === 'none') {
            removeCookie('userRole', { path: '/', domain: '.koodomobile.com' });
        }
        else {
            setCookie('userRole', role, { path: '/', domain: '.koodomobile.com' });
        }
        setUserRole(role);
        setReloadPageOnClose(true);
    };
    return (_jsxs(_Fragment, { children: [_jsx(DebugButton, { type: "button", onClick: function () { var _a; return (_a = triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) === null || _a === void 0 ? void 0 : _a.openDrawer(); }, "data-testid": "btn-feature-flags", children: "Feature Flags" }), _jsx(Drawer, { ref: triggerRef, triggerElements: buttonRef, heading: "Feature Flags", reloadPageOnClose: reloadPageOnClose, children: _jsxs(StackView, { space: 2, tokens: { justifyContent: 'space-between' }, children: [flagEntries.map(function (_a, i) {
                            var key = _a[0], value = _a[1];
                            return (_jsx(Box, { space: 3, variant: { background: value ? 'positive' : 'danger' }, tokens: {
                                    borderTopLeftRadius: '6px',
                                    borderTopRightRadius: '6px',
                                    borderBottomLeftRadius: '6px',
                                    borderBottomRightRadius: '6px'
                                }, children: _jsxs(FlexGrid.Row, { distribute: "between", children: [_jsx(FlexGrid.Col, { xs: 11, children: _jsxs(StackView, { direction: "row", space: 2, tokens: { alignItems: 'center' }, children: [_jsx(Typography, { children: key }), overrideFlags.includes(key) && (_jsx(Icon, { icon: MaintenanceFilled, variant: { size: 'micro' }, accessibilityLabel: "overriding unleash", tokens: { color: palette.color.purple } }))] }) }), _jsx(FlexGrid.Col, { xs: 1, horizontalAlign: "right", children: key !== 'role' && (_jsx(ToggleSwitch, { label: "", initialValue: Boolean(value), onChange: function () { return handleUpdateFlag(key, value ? 0 : 1); } })) })] }, key) }, i));
                        }), _jsxs(_Fragment, { children: [_jsx(Divider, { space: 3 }), _jsx(Typography, { variant: { size: 'h2', colour: 'brand' }, heading: "h1", children: "User Role" }), _jsx(Spacer, { space: 1 }), _jsx(RadioGroup, { items: [
                                        { label: 'none', id: 'none' },
                                        { label: 'qa', id: 'qa' },
                                        { label: 'dev', id: 'dev' }
                                    ], checkedId: userRole, onChange: function (role) { return handleUpdateRole(role); } }), _jsx(Typography, { children: "Selecting this will take precedence over a ban/sub for feature toggles in Unleash." })] })] }) })] }));
};
export default DebuggerFeatureFlags;
// --------------------------- STYLES --------------------------- //
var DebugButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1px;\n  position: fixed;\n  right: 56px;\n  bottom: 19px;\n  background-color: gray;\n  color: white;\n  font-size: 14px;\n  border-radius: 5px;\n  padding: 3px 7px;\n  cursor: pointer;\n  z-index: 9999;\n"], ["\n  border: 1px;\n  position: fixed;\n  right: 56px;\n  bottom: 19px;\n  background-color: gray;\n  color: white;\n  font-size: 14px;\n  border-radius: 5px;\n  padding: 3px 7px;\n  cursor: pointer;\n  z-index: 9999;\n"])));
var templateObject_1;
